import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const pinVariants = cva('', {
  variants: {
    state: {
      allocated: 'fill-blue-600 stroke-blue-900',
      assigned: 'fill-white stroke-blue-600 stroke-2',
      onboarded: 'fill-green-500 stroke-green-900',
      unfindabled: 'fill-orange-400 stroke-orange-800',
      pending: 'fill-black',
    },
  },
  defaultVariants: {
    state: 'pending',
  },
})

const letterVariants = cva('z-10 text-base font-bold leading-[100%]', {
  variants: {
    state: {
      allocated: 'text-white',
      assigned: 'text-blue-600',
      onboarded: 'text-white',
      unfindabled: 'text-orange-800',
      pending: 'text-white',
    },
  },
  defaultVariants: {
    state: 'pending',
  },
})

export interface PinProps extends React.HtmlHTMLAttributes<HTMLDivElement>, VariantProps<typeof pinVariants> {
  letter?: string
}

export const Pin = React.forwardRef<HTMLDivElement, PinProps>(
  ({ className, state, letter: carNumber, ...props }, ref) => {
    const Icon =
      state === 'onboarded'
        ? Icons.flag
        : state === 'pending'
          ? Icons.diamond
          : state === 'assigned'
            ? Icons.pin2
            : Icons.pin

    return (
      <div
        className={cn(
          'relative flex h-9 w-9 justify-center text-base leading-[100%] font-bold tracking-[-0.42px] select-none',
          Icon === Icons.pin || Icon === Icons.pin2 ? 'pt-1.5' : 'pt-2'
        )}
        ref={ref}>
        <p className={cn(letterVariants({ state }))}>{carNumber}</p>

        <div className="absolute top-0 left-0 flex size-9 items-center justify-center">
          <Icon className={cn(pinVariants({ state, className }))} {...props} />
        </div>
      </div>
    )
  }
)
